import axios, { AxiosResponse } from "axios";
import { FeatureToggle, DeploymentRing, FeatureToggleEditRequest } from "../../models/FeatureToggles";

export const getDeploymentRings = (productId: string) => async (): Promise<AxiosResponse<DeploymentRing[]>> => {
	return await axios.get(`/api/v1/${productId}/featureToggles/deploymentRings`);
};

export const getFeatureToggles = (productId: string) => async (): Promise<AxiosResponse<FeatureToggle[]>> => {
	return await axios.get(`/api/v1/${productId}/featureToggles`);
};

export const getFeatureToggle =
	(productId: string, featureToggleId: string) => async (): Promise<AxiosResponse<FeatureToggle>> => {
		return await axios.get(`/api/v1/${productId}/featureToggles/${featureToggleId}`);
	};

export const deleteFeatureToggle = (productId: string, featureToggleId: string) => async (): Promise<AxiosResponse> => {
	return await axios.delete(`/api/v1/${productId}/featureToggles/${featureToggleId}`);
};

export const addFeatureToggle =
	(productId: string, featureToggle: FeatureToggleEditRequest) => async (): Promise<AxiosResponse> => {
		return await axios.post(`/api/v1/${productId}/featureToggles`, featureToggle);
	};

export const editFeatureToggle =
	(productId: string, featureToggleId: string, featureToggle: FeatureToggleEditRequest) =>
	async (): Promise<AxiosResponse> => {
		return await axios.put(`/api/v1/${productId}/featureToggles/${featureToggleId}`, featureToggle);
	};
